import React from 'react';
import { Section } from 'components/FormikForm/Section';
import DatePicker from 'components/partials/Fields/FormikDatePicker';
import { Input } from 'components/partials/Fields/FormikInput';
import moment from 'moment';
import { APP_CONFIG } from 'Config';

const { REACT_APP_IDENTITY_SHOW_SSN } = APP_CONFIG;

interface IdentityInformationProps {
    showIdentityInfo?: boolean
}

const IdentityInformation: React.FC<IdentityInformationProps>= ({ showIdentityInfo }) => {
    if (!showIdentityInfo) return null;

    return (
        <Section title="Identity Information" hasLayout padding>
            <p className="small">
                The following information will be used, in the safest and most protected way possible, to verify your identity. The DOB will be deleted upon verification, while the SSN will be deleted once communicated to EVS (Electronic Verification Systems).
            </p>
            {/*@ts-ignore*/}
            <DatePicker
                formik
                name="birthdate"
                label="Date of Birth"
                minDate={moment().subtract(118, 'year')}
                maxDate={moment().subtract(18, 'year')}
            />
            {REACT_APP_IDENTITY_SHOW_SSN &&
                /*@ts-ignore*/
                <Input
                    formik
                    name="ssn"
                    label="Social Security Number (Optional)"
                />
            }
        </Section>
    );
};

export default IdentityInformation;